module.exports = "https://static.im-cdn.com/mjc/storefront/Anchor/static/media/footerEmail.0a326270.svg";